import Grid from "components/Grid";
import Text from "components/Text";
import { routeConstants } from "constants/routeConstants";
import { FC } from "react";
import { RiSuitcase2Line } from "react-icons/ri";
import { useAppSelector } from "slice";
import CardTitle from "../CardTitle";
import { CardWrapper } from "../PersonalInfo/PersonalInfo.styled";
import {
    ProjectDetails,
    ProjectDetailsLabel,
    Work,
    WorkDate,
} from "./ExperienceAndWork.styled";

export const ExperienceAndWork: FC = () => {
    const { experiences } = useAppSelector((state) => state.user);
    return (
        <CardWrapper>
            <CardTitle
                title="Experience and Work"
                icon={<RiSuitcase2Line />}
                editRoute={
                    routeConstants.profile.editProfile.root +
                    routeConstants.profile.editProfile.experienceDetails
                }
            />
            <Grid row={true} columnGap={1} marginTop={1} rowGap={1}>
                {experiences && experiences.length > 0 ? (
                    experiences.map((exp) => (
                        <Work>
                            <Grid row={true} expanded justify="space-between">
                                <Text
                                    variant="body2"
                                    fontSize="15px"
                                    fontWeight="600"
                                >
                                    {exp.category}
                                </Text>
                                <WorkDate variant="body2">{exp.year}</WorkDate>
                            </Grid>
                            <Grid
                                row={true}
                                direction="column-direction"
                                alignItems="flex-start"
                            >
                                <ProjectDetailsLabel variant="body2">
                                    Project Details
                                </ProjectDetailsLabel>
                                <ProjectDetails variant="body2">
                                    Production: {exp.name_of_production}
                                </ProjectDetails>
                                <ProjectDetails variant="body2">
                                    {exp.role_details}
                                </ProjectDetails>
                            </Grid>
                        </Work>
                    ))
                ) : (
                    <Text variant="body1">No Data Found.</Text>
                )}
            </Grid>
        </CardWrapper>
    );
};
